/**
 * Position Annotations API Client (Chunk 141)
 * Investment thesis tracking for portfolio positions
 */

import apiClient from './client';

export type ThesisStatus = 'bullish' | 'neutral' | 'bearish';

export interface Annotation {
  id: string;
  userId: string;
  symbol: string;
  thesis: string | null;
  personalTargetPrice: number | null;
  thesisStatus: ThesisStatus;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertAnnotationInput {
  thesis?: string | null;
  personalTargetPrice?: number | null;
  thesisStatus?: ThesisStatus;
}

export async function getAnnotations(userId: string): Promise<{ annotations: Annotation[]; total: number }> {
  const res = await apiClient.get<{ annotations: Annotation[]; total: number }>(
    `/analytics/annotations/${encodeURIComponent(userId)}`,
  );
  return res.data;
}

export async function getAnnotation(userId: string, symbol: string): Promise<{ annotation: Annotation }> {
  const res = await apiClient.get<{ annotation: Annotation }>(
    `/analytics/annotations/${encodeURIComponent(userId)}/${encodeURIComponent(symbol)}`,
  );
  return res.data;
}

export async function upsertAnnotation(
  userId: string,
  symbol: string,
  data: UpsertAnnotationInput,
): Promise<{ annotation: Annotation }> {
  const res = await apiClient.put<{ annotation: Annotation }>(
    `/analytics/annotations/${encodeURIComponent(userId)}/${encodeURIComponent(symbol)}`,
    data,
  );
  return res.data;
}

export async function deleteAnnotation(userId: string, symbol: string): Promise<{ success: boolean }> {
  const res = await apiClient.delete<{ success: boolean }>(
    `/analytics/annotations/${encodeURIComponent(userId)}/${encodeURIComponent(symbol)}`,
  );
  return res.data;
}
